import { useQuery } from '@tanstack/react-query';
import {
  InqueryTpbStatementEntity,
  UserWalletTransactionService,
} from 'services/openapi';

import { AccountTPBankQueryKeys } from './constants';

type GetListTransPointDTO = {
  fromTime: string;
  toTime: string;
  accountNumber: string;
  page: string;
  pageSize: string;
};

export const useGetTransactionsOfAccountTPBankListExportQuery = (
  variables: GetListTransPointDTO,
) => {
  const queryKey = [AccountTPBankQueryKeys.GET_TRANSACTIONS, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<InqueryTpbStatementEntity, Error>({
    queryKey: ['export', ...queryKey],
    queryFn: () =>
      UserWalletTransactionService.transactionControllerInqueryTpbStatement(
        variables.fromTime?.trim(),
        variables.toTime?.trim(),
        variables.page,
        variables.pageSize,
        variables.accountNumber,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey: ['export', ...queryKey],
    refetch,
  };
};
